<template>
  <v-container
    fluid
    class="full-height-with-navbar"
  >
    <div class="tabs-bar">
      <v-flex
        d-flex
        class="tabs__wrapper"
      >
        <div
          class="tabs__container tabs__container--overflow"
          :style="`transform: translateX(${translateWidth}px)`"
        >
          <div
            class="tabs__div "
            v-ripple
            v-for="(tab, i) in tabs"
            :key="i"
            @click="model = `tab-${i}`"
            :ref="`tab-${i}`"
            v-if="!tab.feature || features[tab.feature]"
          >
          <span
            class="tabs__item"
            :class="{'tabs__item--active': model === `tab-${i}`}"
          >{{ tab.title }}</span>
          </div>
        </div>
      </v-flex>
    </div>
    <div class="tabs-content">
      <transition name="component-fade" mode="out-in">
        <component
          :is="tabComponent"
          :dates="dates"
          :pickerOptions="pickerOptions"
          @updateInsights="updateInsights"
          :campaigns="campaigns"
        />
      </transition>
    </div>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import AudiencesReport from './audience-report/Index'
  import GeoReport from './geo-report/Index'
  import CampaignsReport from './campaigns-report/Index'
  import IssuesReport from './issues-report/Index'
  import MessagesReport from './messages-report/Index'

  export default {
    name: 'reports',
    components: {
      AudiencesReport,
      GeoReport,
      CampaignsReport,
      IssuesReport,
      MessagesReport
    },
    data () {
      return {
        model: 'tab-1',
        tabs: [
          {
            title: 'Campaigns'
          },
          {
            title: 'Ad groups'
          },
          {
            title: 'Messages'
          },
          {
            title: 'Audiences',
            feature: 'reports_audiences'
          },
          {
            title: 'Geo',
            feature: 'reports_geo'
          }
        ],
        translateWidth: 0,
        counter: 0,
        dates: [],
        pickerOptions: {
          disabledDate (time) {
            return moment(time).unix() > moment().unix()
          }
        }
      }
    },
    mounted () {
      if (!this.reportingDates.length) {
        this.dates.push(this.$moment().subtract(1, 'month')._d)
        this.dates.push(this.$moment()._d)
      } else {
        this.dates.push(this.reportingDates[0])
        this.dates.push(this.reportingDates[1])
      }
    },
    computed: {
      reportingDates () {
        return this.$store.getters.getReportingDates
      },
      tabComponent () {
        switch (this.model) {
          case 'tab-0':
            return 'campaigns-report'
          case 'tab-1':
            return 'issues-report'
          case 'tab-2':
            return 'messages-report'
          case 'tab-3':
            return 'audiences-report'
          case 'tab-4':
            return 'geo-report'
          default:
            return 'campaigns-report'
        }
      },
      features () {
        const version = this.$store.getters.getAppVersion
        return this.$store.getters.getFeatures[version]
      },
      campaigns () {
        return this.$store.getters.getCampaigns
      }
    },
    methods: {
      translatePrev () {
        if (this.counter > 0) {
          this.translateWidth = 0
          this.counter = 0
        }
      },
      translateNext () {
        const element = this.$refs[`tab-${this.counter}`]
        const elWidth = element[0].getBoundingClientRect().width
        if (this.counter < 5) {
          this.translateWidth -= elWidth
          this.counter++
        }
      },
      updateInsights () {
        const payload = {
          startDate: this.$moment(this.reportingDates[0]).format('YYYY-MM-DD'),
          endDate: this.$moment(this.reportingDates[1]).format('YYYY-MM-DD')
        }
        this.$store.dispatch('updateInsights', payload)
      }
    },
    watch: {
      reportingDates (val) {
        this.dates = []
        if (val) {
          this.dates.push(val[0])
          this.dates.push(val[1])
        }
      }
    }
  }
</script>
<style scoped>
  .component-fade-enter-active {
    transition: transform .3s ease;
  }

  .component-fade-enter {
    transform: translateX(500px);
  }
</style>
